<section class="revistas">
  @for (revista of revistas | slice: 0 : particionPublicidad; let i = $index; track revista) {
    <div class="revista" class="revista">
      <a class="url-revista" [routerLink]="['/revista', revista?.id]">
        <img [src]="revista.img" alt="revista.nombre" width="100%" height="100%" />
        <div class="revista-text">
          <span class="revista-nombre">{{ revista.nombre }}</span>
        </div>
      </a>
    </div>
  }
  <div class="publi1 publi-container">
    @if (publicidad_bloques[0]?.enlace) {
      <a href="{{ publicidad_bloques[0]?.enlace }}" target="_blank">
        <img src="{{ publicidad_bloques[0]?.img }}" alt="publicidad" loading="lazy" width="100%" height="100%" />
      </a>
    } @else {
      <div id="DIVISOR_SECCION_1" class="publicidad DIVISOR_SECCION_1"></div>
    }
  </div>
  <div class="publi1 publi-container-movil">
    @if (publicidad_bloques[0]?.enlace) {
      <!-- todo pub movil -->
    } @else {
      <div id="publi-movil-0" class="publicidad publi-movil-0"></div>
    }
  </div>
  @for (revista of revistas | slice: particionPublicidad : 2 * particionPublicidad; let i = $index; track revista) {
    <div class="revista" class="revista">
      <a class="url-revista" [routerLink]="['/revista', revista?.id]">
        <img [src]="revista.img" alt="revista.nombre" width="100%" height="100%" />
        <div class="revista-text">
          <span class="revista-nombre">{{ revista.nombre }}</span>
        </div>
      </a>
    </div>
  }
  <div class="publi2 publi-container">
    @if (publicidad_bloques[1]?.enlace) {
      <a href="{{ publicidad_bloques[1]?.enlace }}" target="_blank">
        <img src="{{ publicidad_bloques[1]?.img }}" alt="publicidad" loading="lazy" width="100%" height="100%" />
      </a>
    } @else {
      <div id="DIVISOR_SECCION_2" class="publicidad-container DIVISOR_SECCION_2"></div>
    }
  </div>
  <div class="publi2 publi-container-movil">
    @if (publicidad_bloques[1]?.enlace) {
      <!-- todo pub movil -->
    } @else {
      <div id="publi-movil-1" class="publicidad publi-movil-1"></div>
    }
  </div>
  @for (revista of revistas | slice: 2 * particionPublicidad : revistas?.length; let i = $index; track revista) {
    <div class="revista" class="revista">
      <a class="url-revista" [routerLink]="['/revista', revista?.id]">
        <img [src]="revista.img" alt="revista.nombre" width="100%" height="100%" />
        <div class="revista-text">
          <span class="revista-nombre">{{ revista.nombre }}</span>
        </div>
      </a>
    </div>
  }
  <div class="publi3 publi-container">
    @if (publicidad_bloques[2]?.enlace) {
      <a href="{{ publicidad_bloques[2]?.enlace }}" target="_blank">
        <img src="{{ publicidad_bloques[2]?.img }}" alt="publicidad" loading="lazy" width="100%" height="100%" />
      </a>
    } @else {
      <div id="DIVISOR_SECCION_3" class="publicidad-container DIVISOR_SECCION_3"></div>
    }
  </div>
  <div class="publi3 publi-container-movil">
    @if (publicidad_bloques[2]?.enlace) {
      <!-- todo pub movil -->
    } @else {
      <div id="publi-movil-2" class="publicidad publi-movil-2"></div>
    }
  </div>
</section>
